import {
	type PriceInfo,
	PriceService,
} from "../../../services/PriceService/PriceService";
import type { Timeframes } from "../../../types";
import { getDefaultParams } from "./CustomIndicatorService";
import type { IndicatorsService } from "./getIndicatorsService";

export class DefaultIndicatorService implements IndicatorsService {
	async getBarData(
		from: number,
		to: number,
		interval: Timeframes,
		ticker: string,
	): Promise<PriceInfo[]> {
		const response = await PriceService.create().getData(
			getDefaultParams(from, to, ticker),
			interval,
		);

		return response.data ?? [];
	}
}
